import type { MailDispatchSummary } from '../types/api';

/**
 * One sentence describing what happened to the outbound RFP emails, for a toast. Returns null
 * when there is nothing worth saying (a plain save with no send).
 */
export function mailSummaryMessage(mail: MailDispatchSummary | undefined | null): string | null {
  if (!mail) return null;

  if (mail.attempted === 0) {
    if (mail.note) return `${mail.note}.`;

    const alreadyEmailed = (mail.results ?? []).filter((result) =>
      (result.error ?? '').includes('already emailed'),
    ).length;

    if (alreadyEmailed > 0 && alreadyEmailed === mail.skipped) {
      return `No new emails: all ${alreadyEmailed} vendor(s) were already emailed for this RFP.`;
    }

    if (mail.skipped > 0) return `No emails were sent (${mail.skipped} vendor(s) skipped).`;
    return null;
  }

  const parts = mail.dryRun
    ? [`${mail.previewed} email(s) prepared (dry run - nothing was sent)`]
    : [`${mail.sent} email(s) sent to vendors`];

  if (mail.failed > 0) parts.push(`${mail.failed} failed`);
  if (mail.skipped > 0) parts.push(`${mail.skipped} skipped`);

  const sandbox = mail.sandboxRedirect ? ` (sandboxed to ${mail.sandboxRedirect})` : '';
  return `${parts.join(', ')}${sandbox}.`;
}
